var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('router-view'),_c('News')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }